import { BIButton, globalTheme } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import styled from 'styled-components';

export const EditButton = styled(BIButton)`
  text-decoration: underline;
  font-weight: ${globalTheme.fonts.plainSemiboldText.fontWeight};
  color: ${globalTheme.colors.textSecondary};
  padding: 0;
`;

export const AppliedText = styled(DsTypography)`
  word-break: break-word;
`;
